let cardCarouselTimer = null;
let cardCarouselLock = false;
let cardCarouselPause = false;
const cardCarouselDelay = 5000;
const cardCarouselTransitionDuration = 400; // corresponds to value in CSS

const shiftCardCarousel = (carousel, direction) => {
    if (direction === 'auto' && cardCarouselPause) {
        return;
    }
    if (cardCarouselLock) {
        return;
    } else {
        cardCarouselLock = true;
    }
    let cardContainer = $(carousel).find('.card-carousel-cards');
    let numCards = $(cardContainer).children().length / 2;
    let i = -numCards;
    
    if (direction === 'back') {
        // Update classes
        i = 1 - numCards;
        $(cardContainer).children().each(function(){
            let pos = i;
            if (i < -2) {
                pos = '-x';
            } else if (i > 2) {
                pos = 'x';
            }
            $(this).attr('data-pos', pos);
            i++;
        });

        // Move last in DOM order to first (after transitions complete)
        setTimeout(function(){
            $(cardContainer).children().last().detach().attr('data-pos', '-x').prependTo(cardContainer);
        }, 250);
    } else {
        // Move first in DOM order to last
        $(cardContainer).children().first().detach().attr('data-pos', 'x').appendTo(cardContainer);

        // Update classes
        // This one has a 100ms delay so the DOM change above can pickup the transition effect
        setTimeout(function(){
            i = -numCards;
            // this each() is the same as above, could be abstracted
            $(cardContainer).children().each(function(){
                let pos = i;
                if (i < -2) {
                    pos = '-x';
                } else if (i > 2) {
                    pos = 'x';
                }
                $(this).attr('data-pos', pos);
                i++;
            });
        }, 100);
    }

    setTimeout(function(){
        cardCarouselLock = false;
    }, cardCarouselTransitionDuration);
}

const prepareCardCarousel = (carousel) => {
    let cardContainer = $(carousel).find('.card-carousel-cards');
    
    // Start auto shift
    cardCarouselTimer = (
        setInterval(
            () => shiftCardCarousel(carousel, 'auto'),
            cardCarouselDelay
        )
    );
    
    // Bind event to shift slides if pos 1 or -1 are clicked
    $(cardContainer).on('click', function(e) {
        let direction = 'forward';
        if (
            !cardCarouselLock && (
                $(e.target).data('pos') == '1'
                || $(e.target).data('pos') == '-1'
                || $(e.target).parents('[data-pos="1"]').length > 0
                || $(e.target).parents('[data-pos="-1"]').length > 0
            )
        ) {
            e.preventDefault();
            clearInterval(cardCarouselTimer);
            if (
                $(e.target).data('pos') == '-1'
                || $(e.target).parents('[data-pos="-1"]').length > 0
            ) {
                direction = 'back';
            }
            shiftCardCarousel(carousel, direction);
            cardCarouselTimer = (
                setInterval(
                    () => shiftCardCarousel(carousel, 'auto'),
                    cardCarouselDelay
                )
            );
        }
    });

    // Pause on mouseover
    $(cardContainer).on('mouseover', function(){
        cardCarouselPause = true;
    }).on('mouseout', function(){
        cardCarouselPause = false;
    });

    // Enable swipe gestures
    let hammertime = new Hammer(carousel);
    hammertime.on('swipeleft', function(ev) {
        if (!cardCarouselLock) {
            clearInterval(cardCarouselTimer);
            shiftCardCarousel(carousel, 'back');
            cardCarouselTimer = (
                setInterval(
                    () => shiftCardCarousel(carousel, 'forward'),
                    cardCarouselDelay
                )
            );
        }
    });
    hammertime.on('swiperight', function(ev) {
        if (!cardCarouselLock) {
            clearInterval(cardCarouselTimer);
            shiftCardCarousel(carousel, 'forward');
            cardCarouselTimer = (
                setInterval(
                    () => shiftCardCarousel(carousel, 'forward'),
                    cardCarouselDelay
                )
            );
        }
    });
}

const initialize = () => {
    $('.card-carousel').each(function(){
        prepareCardCarousel(this);
    });
};

export default {
    initialize,
};